import { IBook } from './types';
import Books from '.';
import memoizee from 'memoizee';
import { TBookAlias } from '@shared/book/interfaces';

export const getBookByAlias = memoizee(
  (alias: TBookAlias): IBook => Books.find((b) => b.alias === alias),
);
